import vsComponent from './vsTextarea';

export default Vue => {
  Vue.component(vsComponent.name, vsComponent);
};
